// extracted by mini-css-extract-plugin
export default {"edit_your_box":"Fn","edit_box_title":"Gn","subscription":"Hn","byb":"In","recommended_for_you_title":"Jn","explore":"Kn","recommended":"Ln","go_back":"Mn","wrapper":"Nn","product_img":"On","info":"Pn","remove_btn":"Qn"};
    if(module.hot) {
      // 1726593103129
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  